import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  LayoutDashboard,
  ShoppingBag,
  User,
  ShoppingCart,
  LogOut,
   Settings,
    Menu,
    X
} from "lucide-react";
import { useState, useContext } from "react";
import { AuthContext } from "../context/AuthContext";

function BuyerSidebar() {
  const location = useLocation();
  const navigate = useNavigate();

  const { logout } = useContext(AuthContext);

  const [open, setOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate("/login");
  };


  const menuItems = [
    {
      name: "Dashboard",
      path: "/buyer",
      icon: <LayoutDashboard size={20} />,
    },
    {
      name: "My Orders",
      path: "/buyer/my-orders",
      icon: <ShoppingBag size={20} />,
    },
    // {
    //   name: "Profile",
    //   path: "/buyer/profile",
    //   icon: <User size={20} />,
    // },
    {
      name: "Cart",
      path: "/buyer/cart",
      icon: <ShoppingCart size={20} />,
    },
     {
      name: "Profile",
      path: "/buyer/settings",
      icon: <Settings size={20} />,
    },
  ];

  return (
     <>
      {/* Mobile Header */}
      <div className="lg:hidden flex items-center justify-between bg-slate-900 text-white px-4 py-3 shadow-md">
        <h1 className="text-xl font-bold">Buyer Panel</h1>

        <button onClick={() => setOpen(true)}>
          <Menu size={28} />
        </button>
      </div>

      {/* Overlay */}
      {open && (
        <div
          className="fixed inset-0 bg-black/40 z-40 lg:hidden"
          onClick={() => setOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside
        className={`fixed top-0 left-0 z-50 h-screen w-64 bg-slate-900 text-white flex flex-col transition-transform duration-300
        ${
          open ? "translate-x-0" : "-translate-x-full"
        }
        lg:translate-x-0 lg:static`}
      >
        {/* Header */}
        <div className="p-6 border-b border-slate-700 flex items-center justify-between">
          <h1 className="text-2xl font-bold">Buyer Panel</h1>

          <button
            className="lg:hidden"
            onClick={() => setOpen(false)}
          >
            <X size={28} />
          </button>
        </div>

        {/* Menu */}
        <div className="flex-1 p-4">
          <ul className="space-y-2">
            {menuItems.map((item) => (
              <li key={item.path}>
                <Link
                  to={item.path}
                  onClick={() => setOpen(false)}
                  className={`flex items-center gap-3 px-4 py-3 rounded-lg transition
                    ${
                      location.pathname === item.path
                        ? "bg-blue-600"
                        : "hover:bg-slate-800"
                    }`}
                >
                  {item.icon}
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Logout */}
        <div className="p-4 border-t border-slate-700">
          <button
            onClick={handleLogout}
            className="w-full flex items-center gap-3 px-4 py-3 rounded-lg hover:bg-red-600 transition"
          >
            <LogOut size={20} />
            Logout
          </button>
        </div>
      </aside>
    </>
  );
}

export default BuyerSidebar;